import React from "react";

import { Table, Tag, Button } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

//import Settings from "./settings";
import Settings from "../../job/task/settings";

const Tasks = (props) => {
    const getServiceName = (service) =>
        props.servicesById && service ? props.servicesById[service].name : service ? service.name : "";
    const expandedRowRender = (record) => {
        const receivables = record.qTaskFinances;

        let merge = receivables.map((e) => {
            return {
                id: e.id,
                count: Number.parseInt(e.count),
                type: e.catlogValue.name,
                percent: e.percent,
                clientRateValue: e.rateValue,
                clientSubtotalValue: e.subtotalValue,
            };
        });

        merge = merge.filter((e) => e.vendorSubtotalValue > 0 || e.clientSubtotalValue > 0);

        const columns = (props) => {
            const __columns = [
                { title: "", dataIndex: "", key: "1", width: 50 },
                { title: "#", dataIndex: "count", key: "count", align: "right", width: 50 },
                {
                    title: "Type",
                    dataIndex: "type",
                    key: "type",
                    width: 50,
                },
                { title: "%", dataIndex: "percent", key: "percent", align: "right", width: 50 },
            ];

            if (props.vendor) {
                __columns.push({
                    title: "Vendor Rate",
                    dataIndex: "vendorRateValue",
                    key: "vendorRateValue",
                    align: "right",
                    width: 100,
                });
            }

            if (props.client) {
                __columns.push({
                    title: "Client Rate",
                    dataIndex: "clientRateValue",
                    key: "clientRateValue",
                    align: "right",
                    width: 100,
                });
            }

            if (props.vendor) {
                __columns.push({
                    title: "Vendor Subtotal",
                    dataIndex: "vendorSubtotalValue",
                    key: "vendorSubtotalValue",
                    align: "right",
                    width: 100,
                });
            }

            if (props.client) {
                __columns.push({
                    title: "Client Subtotal",
                    dataIndex: "clientSubtotalValue",
                    key: "clientSubtotalValue",
                    align: "right",
                    width: 100,
                });
            }

            return __columns;
        };
        /*
        const columnsVendor = [
            { title: "", dataIndex: "", key: "1", width: 50 },
            { title: "#", dataIndex: "count", key: "count", align: "right", width: 50 },
            {
                title: "Type",
                dataIndex: "type",
                key: "type",
                width: 50,
            },
            { title: "%", dataIndex: "percent", key: "percent", align: "right", width: 50 },
            { title: "Rate", dataIndex: "vendorRateValue", key: "vendorRateValue", align: "right", width: 100 },
            {
                title: "Subtotal",
                dataIndex: "vendorSubtotalValue",
                key: "vendorSubtotalValue",
                align: "right",
                width: 100,
            },
        ];
        */

        return (
            <Table
                columns={columns(props)}
                rowKey={(record) => record.id}
                dataSource={merge || []}
                pagination={false}
                title={() => <Settings task={record} />}
            />
        );
    };
    const columns = (props) => {
        const __columns = [
            { title: "#", dataIndex: "code", key: "order", width: 50 },
            {
                title: "Service",
                dataIndex: "service",
                key: "service",
                render: (service, record) => {
                    return <>{getServiceName(service)}</>;
                },
            },
            {
                title: "Category",
                dataIndex: "serviceCategory",
                key: "category",
                render: (category, record) => {
                    if (category) {
                        return <>{category?.name}</>;
                    } else {
                        return null;
                    }
                },
            },
            {
                title: "Language(s)",
                dataIndex: "languageType",
                key: "languageType",
                render: (type, record) => {
                    if (type == "Single") {
                        if (record.languageFamily == "LTR" || record.languageFamily == "RTL") {
                            return <>{record.languageFamily}</>;
                        }
                        return <>{record.language?.code}</>;
                    } else {
                        return <>{record.languagePair?.code}</>;
                    }
                },
            },
            {
                title: "Unit",
                dataIndex: "baseUnit",
                key: "unit",
                render: (unit, record) => {
                    if (unit) {
                        if (record.isWord) {
                            return <>{record.effectiveWordCount} WC</>;
                        } else {
                            return (
                                <>
                                    {record.baseUnitAmount} {unit.name}
                                </>
                            );
                        }
                    }
                },
            },
        ];

        if (props.vendor) {
            __columns.push({
                title: "Vendor",
                dataIndex: "vendor",
                key: "vendor",
                render: (vendor) => {
                    if (vendor) {
                        return <>{vendor.name}</>;
                    }
                },
            });
        }

        if (props.vendor) {
            __columns.push({
                title: "Vendor Price",
                dataIndex: "totalToPayValue",
                key: "vendorPrice",
                align: "right",
                render: (price, record) => (
                    <>
                        {price} {record.totalToPayType}
                    </>
                ),
            });
        }

        if (props.client) {
            __columns.push({
                title: "Client Price",
                dataIndex: "totalToReceiveValue",
                key: "clientPrice",
                align: "right",
                render: (price, record) => (
                    <>
                        {price} {record.totalToReceiveType}
                    </>
                ),
            });
        }

        return __columns;
    };

    return (
        <>
            <Table
                size="small"
                className="components-table-demo-nested"
                columns={columns(props)}
                expandable={{
                    expandedRowRender,
                    rowExpandable: (record) => record.catlog,
                }}
                rowKey={(record) => record.id}
                dataSource={props.tasks}
                pagination={false}
            />
        </>
    );
};

export default Tasks;
